import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

// All the imports from common
import Banner from '../common/Banner/Banner';
import AdBanner from '../common/AdBanner/AdBanner';
import OuterBox from '../common/OuterBox/OuterBox';
import InnerBox from '../common/InnerBox/InnerBox';
import Latest from '../common/Latest/Latest';
import BannerLoader from '../common/Loaders/BannerLoader';
import { ListElement, Image } from '../common/StyledComponents';
import { SideBar } from '../common/StyledComponents/StyledSideBar';

// All the imports related to Ads
import adLinkedin from '../../assets/images/ad-linkedin.png';
import adAmazon from '../../assets/images/ad-amazon.png';
import adAmazonVertical from '../../assets/images/ad-amazon-vertical.png';
import adTissot from '../../assets/images/ad-tissot.png';
import adSuggested from '../../assets/images/ad-suggested.png';
import adSuggestedVertical from '../../assets/images/ad-suggested-vertical.png';

class Internet extends Component {
  componentWillMount = () => {
    // console.log('[Internet.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('[Internet.js] - CDM');
    // console.log('[News.js] componentDidMount');
    this.props.onFetchInternetBanner();
    this.props.onFetchLatestInternet(1);
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('[Internet.js] - CDUp');
    // Make API requests according to the page that needs to be fetched.
  };

  handleLoadMore = () => {
    this.props.onFetchLatestInternet(this.props.pageForLatestInternet);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    // console.log('this.props: ', this.props);
    const { internetBannerData, latestInternet } = this.props;
    return (
      <div className="Internet">
        <AdBanner height="250px" width="970px" margin="1rem 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {internetBannerData ? (
          <Banner bannerData={internetBannerData} clicked={this.navigate} />
        ) : (
          <BannerLoader />
        )}

        <OuterBox>
          <InnerBox>
            <Latest
              title="Internet"
              titleProps={{
                fontFamily: 'Montserrat',
                fontSize: '2.25rem',
                fontWeight: 'bold'
              }}
              contentData={latestInternet}
              handleLoadMore={this.handleLoadMore}
              clicked={this.navigate}
            />

            <SideBar>
              <AdBanner height="250px" width="300px" margin="0 0 18px 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="565px" width="300px" margin="0">
                <Image
                  src={adSuggestedVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                <Image
                  src={adAmazonVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              <AdBanner height="250px" width="300px" margin="0 0 18px 0">
                <Image
                  src={adLinkedin}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </SideBar>
          </InnerBox>
        </OuterBox>

        <AdBanner height="250px" width="970px" margin="0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        <OuterBox>
          <InnerBox>
            <ListElement className="w-100" maxwidth="100%" padding="20px">
              <AdBanner height="346px" width="1040px" margin="0">
                <Image
                  src={adSuggested}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </ListElement>
          </InnerBox>
        </OuterBox>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state.internet: ', state.internet);
  return {
    loading: state.internet.loading,
    internetBannerData: state.internet.internetBannerData,
    latestInternet: state.internet.latestInternet,
    pageForLatestInternet: state.internet.pageForLatestInternet
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchInternetBanner: () => dispatch(Creators.fetchInternetBanner()),
  onFetchLatestInternet: page => dispatch(Creators.fetchLatestInternet(page))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Internet);
